<template>
  <section class="river-selector">
    <individual-card-selector
      ref="flop1"
      v-bind:cardString="presetCommunityCards.flop1"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:hideDeselect="true"
      v-bind:disabled="true"
      v-on:select="setIndividualPresetCommunityCard($event, 'flop1')"
      v-on:deselect="$emit('removePresetCommunityCard', 'flop1')"
    />
    <individual-card-selector
      ref="flop2"
      v-bind:cardString="presetCommunityCards.flop2"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:hideDeselect="true"
      v-bind:disabled="true"
      v-on:select="setIndividualPresetCommunityCard($event, 'flop2')"
      v-on:deselect="$emit('removePresetCommunityCard', 'flop2')"
    />
    <individual-card-selector
      ref="flop3"
      v-bind:cardString="presetCommunityCards.flop3"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:hideDeselect="true"
      v-bind:disabled="true"
      v-on:select="setIndividualPresetCommunityCard($event, 'flop3')"
      v-on:deselect="$emit('removePresetCommunityCard', 'flop3')"
    />
    <individual-card-selector
      ref="turn"
      v-bind:cardString="presetCommunityCards.turn"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:hideDeselect="true"
      v-bind:disabled="true"
      v-on:select="setIndividualPresetCommunityCard($event, 'turn')"
      v-on:deselect="$emit('removePresetCommunityCard', 'turn')"
    />
    <individual-card-selector
      ref="river"
      v-bind:cardString="presetCommunityCards.river"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:disabled="disabled"
      v-on:select="setIndividualPresetCommunityCard($event, 'river')"
      v-on:deselect="$emit('removePresetCommunityCard', 'river')"
    />
  </section>
</template>

<script>
import IndividualCardSelector from '@/components/controls/card-selection/individual-card-selector';

export default {
  name: 'river-selector',
  components: {
    'individual-card-selector': IndividualCardSelector,
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled'],
  computed: {
    presetCards: function () {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    },
  },
  methods: {
    setIndividualPresetCommunityCard: function (payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'river') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function (previousPosition) {
      let nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function (previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else if (previousPosition === 'turn') {
        return 'river';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/controls/card-selection/river-selector.vue